// extracted by mini-css-extract-plugin
export default {"option":"_4n291"};